import { Injectable } from '@angular/core';
import { sideBarTokenizer } from '../store';

@Injectable()
export class SideBarFacadeService {
  private readonly _sideBarTokenized = sideBarTokenizer();
  $toggleSideBar = this._sideBarTokenized.$toggleSideBar;
}
